// ─────────────────────────────────────────────────────────────
// Btn
// Extracted from App.js.
// ─────────────────────────────────────────────────────────────

import { C } from "../../lib/colors";

export function Btn({ children, onClick, variant = "primary", disabled, style }) {
  const styles = {
    primary: { background: `linear-gradient(135deg, ${C.green}, #00c853)`, color: "#000", border: "none" },
    ghost: { background: "transparent", color: C.sub, border: `1px solid ${C.border}` },
    danger: { background: C.red + "18", color: C.red, border: `1px solid ${C.red}30` },
    blue: { background: `linear-gradient(135deg, ${C.blue}, #6366f1)`, color: "#fff", border: "none" },
  };
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ padding: "10px 18px", borderRadius: 10, fontSize: 13, fontWeight: 700, cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.5 : 1, transition: "all 0.15s", letterSpacing: "0.04em", ...styles[variant], ...style }}>
      {children}
    </button>
  );
}

// ─────────────────────────────────────────────────────────────
// SETUP BANNER
// ─────────────────────────────────────────────────────────────
